import React from "react";
import styled from "styled-components";
import ItemEntry from "./ItemEntry";
import get from "lodash/get";

function ItemsList({readOnly = false, items, errors = [], style, className, footer}) {
  function getItemError(item) {
    return errors.find(
      error => get(error, "extra_info.item.uuid", null) === item.getId()
    );
  }

  if (items.length) {
    return (
      <Container>
        <ProductsList style={style} className={className}>
          {items.map(item => (
            <li key={item.getId()}>
              <ItemEntry item={item} readOnly={readOnly} error={getItemError(item)} />
            </li>
          ))}
        </ProductsList>
        {footer}
      </Container>
    );
  } else {
    return (
      <EmptyPlaceholderContainer>
        <PlaceholderText>Your cart is empty.</PlaceholderText>
        {footer}
      </EmptyPlaceholderContainer>
    );
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: ${({theme}) => theme.v2.spacing(4)};
`;

const ProductsList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-width: 100%;
  box-sizing: border-box;

  > li:not(:last-child) {
    margin-bottom: 24px;
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 11px;
  }
  &::-webkit-scrollbar:horizontal {
    height: 11px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 3px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, 0.5);
  }
`;
const EmptyPlaceholderContainer = styled.section`
  min-height: 160px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  padding-bottom: ${({theme}) => theme.v2.spacing(4)};
`;

const PlaceholderText = styled.h1`
  display: flex;
  flex: 1;
  align-items: center;
  font-size: ${({theme}) => theme.v2.typography.sizing.xl.lg};
  color: #989ba3;
`;

export default ItemsList;
